module.exports = __webpack_public_path__ + "img/roomi tv 32_ led tv.8a1a02bd.jpg";